/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";

/**
* Comorbidities service.
* @module api/ComorbiditiesApi
* @version v0.3
*/
export default class ComorbiditiesApi {

    /**
    * Constructs a new ComorbiditiesApi. 
    * @alias module:api/ComorbiditiesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the comorbiditiesGet operation.
     * @callback moduleapi/ComorbiditiesApi~comorbiditiesGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Search Comorbidities by name
     * @param {String} search Name search term
     * @param {module:api/ComorbiditiesApi~comorbiditiesGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    comorbiditiesGet(search, callback) {
      
      let postBody = null;
      // verify the required parameter 'search' is set
      if (search === undefined || search === null) {
        throw new Error("Missing the required parameter 'search' when calling comorbiditiesGet");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'search': search
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/comorbidities', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}